import { ISiteSettingsForSiteAdmin } from '../../../settings/interfaces/ISiteSettingsForSiteAdmin';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetSiteSettingsForSiteAdminParams {
  id: string;
}

export interface IGetSiteSettingsForSiteAdminResult extends IResult {
  siteSettings: ISiteSettingsForSiteAdmin;
}


export class GetSiteSettingsForSiteAdminRequest extends Request<IGetSiteSettingsForSiteAdminParams, IGetSiteSettingsForSiteAdminResult> {
  constructor(params: IGetSiteSettingsForSiteAdminParams) {
    super('getSiteSettingsForSiteAdmin', params);
  }
}
